import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { CheckIcon } from 'lucide-react';
import Link from 'next/link';
import React from 'react';
import type { BreadcrumbItemNavigation } from '@/modules/shared/types/breadcrumb';
interface MobileItemProps {
  item: BreadcrumbItemNavigation;
  isCurrent: boolean;
  onClick: () => void;
}
function MobileItem(t0) {
  const $ = _c(12);
  const {
    item,
    isCurrent,
    onClick
  } = t0;
  let t1;
  if ($[0] !== isCurrent) {
    t1 = cn("md:hover:bg-accent flex w-full items-center justify-between gap-2 rounded-md px-3 py-2", {
      "bg-accent": isCurrent
    });
    $[0] = isCurrent;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== item.href || $[3] !== item.label) {
    t2 = <Link href={item.href} className="text-foreground w-full gap-2 truncate text-sm/5.5">{item.label}</Link>;
    $[2] = item.href;
    $[3] = item.label;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== isCurrent) {
    t3 = isCurrent && <CheckIcon className="text-foreground h-4 w-4" />;
    $[5] = isCurrent;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== onClick || $[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
    t4 = <div onClick={onClick} className={t1}>{t2}{t3}</div>;
    $[7] = onClick;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}
export { MobileItem };